/**
 * EhrQuestionsSection - the /ehr questions, laid out like the homepage's
 * FaqSection (same heading, column and rows) and placed, like it, right
 * before the closing ask. The heading names the doubt the page exists to
 * clear. The answers live in ehr-faq.ts, which also feeds the page's
 * FAQPage JSON-LD.
 */

import { Link } from "react-router";
import { FaqList, type FaqItem } from "@/components/landing/home/FaqList";
import { EHR_FAQS, type EhrFaq } from "./ehr-faq";
import { EhrHeading } from "./EhrHeading";

function answer({ a, link }: EhrFaq) {
  if (!link) return a;
  const at = a.indexOf(link.text);
  return (
    <>
      {a.slice(0, at)}
      <Link to={link.to}>{link.text}</Link>
      {a.slice(at + link.text.length)}
    </>
  );
}

const ITEMS: FaqItem[] = EHR_FAQS.map((faq) => ({ q: faq.q, a: answer(faq) }));

export function EhrQuestionsSection() {
  return (
    <section
      id="questions"
      data-screen-label="Questions"
      className="home-anim ehr-faq-section"
      style={{
        position: "relative",
        padding: "130px 24px 40px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        color: "hsl(225 45% 14%)",
      }}
    >
      <div style={{ width: "100%", maxWidth: 820, display: "flex", flexDirection: "column" }}>
        <EhrHeading
          lead="The usual questions."
          beat="It does sound too good to be true."
          ownLine
          align="left"
          marginBottom={56}
        />
        <FaqList items={ITEMS} />
      </div>

      <style>{`
        @media (max-width: 768px) {
          .ehr-faq-section {
            padding-top: 88px !important;
          }
        }
      `}</style>
    </section>
  );
}
